module.exports = function () {
    function DynamicContentProductGroupController(productGroupService) {
        productGroupService.selectProductGroup(this.groupName).then((group) => {
            this.productGroupExists = group !== undefined;
        });
    }

    return {
        restrict: 'E',
        scope: {
            groupName: '@',
        },
        bindToController: true,
        controllerAs: 'ctrl',
        controller: ['ProductGroupService', DynamicContentProductGroupController],
        template: `
            <oly-dc-product-group-tile-list
                ng-if="ctrl.productGroupExists"
                product-group-id="ctrl.groupName">
            </oly-dc-product-group-tile-list>
        `,
    };
};



// WEBPACK FOOTER //
// ./src/common/dynamiccontent/dynamic-content-product-group.directive.js